import script from "./NoEventsIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./NoEventsIcon.vue?vue&type=script&setup=true&lang=js"

export default script